// Rebuilds the nested Ops sidebar menu tree from the flat Spr_FetchMenuForOps rows.
// Non-obvious rules: order siblings by MenuId asc (not SortOrder/Priority); prune empty
// branches (no path and no children).
export function buildOpsMenuTree(rows: any[]): any[] {
  const visible = (rows || []).filter(
    (r) => r.IsHide !== true && r.IsHide !== 1 && String(r.IsHide).toLowerCase() !== 'true'
  );

  const build = (parentId: any): any[] =>
    visible
      .filter((r) => String(r.ParentMenuId) === String(parentId))
      .sort((a, b) => Number(a.MenuId) - Number(b.MenuId))
      .map((r) => {
        const children = build(r.MenuId);
        return {
          path: (r.NavigateUrl || '').toString().trim(),
          title: r.MenuDesc,
          icon: r.MenuIcon,
          type: children.length > 0 ? 'sub' : 'link',
          active: false,
          children,
        };
      })
      .filter((n) => n.path !== '' || n.children.length > 0);

  return build(0);
}
